import React from "react";
import { logo } from "../../../commons/PanelImagepath";
import "./login.css";

/**
 * Centered single-column card for the login, lock-screen and forgot-password pages.
 * Phones: full-width card with comfortable padding; larger screens: a 420px card.
 */
const AuthLayout = ({ children, className = "" }) => (
  <main className={`auth-page ${className}`}>
    <div className="auth-page__card">
      <img className="auth-page__logo" src={logo} alt="Logo" />
      {children}
    </div>
  </main>
);

export default AuthLayout;
